export default [{
	path: 'system/configs',
	name: 'System',
	component: resolve => require(['@/views/System/index.vue'], resolve),
	meta: {
		title: '系统设置',
		name: 'System',
	}
}];


// WEBPACK FOOTER //
// ./src/router/modules/system.route.js